<template>
  <div class="form-signin">
    <div class="form-signin-heading">
      <h1 class="sign-title">登 录</h1>
      <img width="150"
           src="~@assets/logo/logo-300.png"
           alt="">
    </div>
    <div class="login-wrap">
      <el-form ref="loginForm"
               :rules="rules"
               :model="form"
               label-position="left">
        <el-form-item prop="name">
          <el-input
            v-model="form.name"
            placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item prop="captchacode" v-if="accountOrPwdWrong">
          <div class="captchacode-container">
            <el-input
              v-model="form.captchacode"
              placeholder="验证码"></el-input>
            <img :src="codeImageData" @click="refreshCaptchaCode" style="margin-left: 10px; width: 50px; height: 25px"/>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            class="submit-btn"
            type="primary"
            @click="login"
            :loading="loading">
            <i class="el-icon-check"></i>
          </el-button>
        </el-form-item>
        <div class="login-error"
             v-if="errorMsg != ''">{{ errorMsg }}
        </div>
        <!-- <div class="registration">
          还未拥有账户?
          <a class="" href="registration.html">
            注册
          </a>
        </div> -->
      </el-form>
    </div>
  </div>
</template>

<script>
import request from '@core/api/request'
import store from '@store'

export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      errorMsg: '',
      accountOrPwdWrong: false,
      codeImageData: '',
      form: {
        name: '',
        password: '',
        captchacode: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 2, max: 20, message: '用户名长度在 2 到 20 个字符', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 3, max: 60, message: '密码长度在 3 到 60 个字符', trigger: 'blur'},
        ],
        captchacode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ]
      },
      isForcePwd: false
    }
  },
  mounted () {
    document.addEventListener('keyup', this.keyup)
  },
  destroyed () {
    document.removeEventListener('keyup', this.keyup)
  },
  methods: {
    keyup (e) {
      let keyCode = e.keyCode || e.which || e.charCode
      if (keyCode === 13) {
        this.login()
      }
    },
    async login () {
      const reinforcesWitchResult = await request('reinforcesWitch')
      this.isForcePwd = reinforcesWitchResult.data
      this.errorMsg = ''
      this.loading = true
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const params = filter.copyJson(this.form)
          if (this.isForcePwd && this.accountOrPwdWrong) {
            params.captchaCodeToken = this.captchaCodeToken
          }
          request('login', params).then(async ({data}) => {
            store.commit('LOGIN', data.jwt)
            store.commit('SET_PERMISSIONS', [])

            await request.common('getVersion')
            // 用户权限控制
            if (store.state.login.user.usertype === '1') {
              this.goHomeOrChangePwdPage(this.form.password)
            } else {
              let loginFailed = () => {
                store.commit('LOGOUT')
                this.errorMsg = '登录失败，网络异常'
                this.loading = false
              }
              request('getPermission').then(({data}) => {
                store.commit('SET_PERMISSIONS', data)
              }).catch(loginFailed)
                .then(() => {
                  request('getApiPermission').then(({data}) => {
                    store.commit('SET_API_PERMISSIONS', data)
                    this.goHomeOrChangePwdPage(this.form.password)
                  }).catch(loginFailed)
                })
            }
          }).catch((error) => {
            if (error.response) {
              if (error.response.data.ret === 403) {
                this.errorMsg = '登录失败，禁止访问'
              } else if ([405, 412].includes(error.response.data.ret)) {
                this.errorMsg = error.response.data.msg
              } else {
                this.errorMsg = '登录失败，用户名或密码错误'
                if (this.isForcePwd) {
                  this.accountOrPwdWrong = true
                  this.refreshCaptchaCode()
                }
              }
            } else {
              this.errorMsg = '网络错误'
            }
            this.loading = false
          })
        } else {
          this.loading = false
          return false
        }
      })
    },
    goHomeOrChangePwdPage (pwd) {
      if (this.isForcePwd) {
        if (this.isStrongPwd(pwd)) {
          this.$emit('login')
        } else {
          this.$router.push({path: '/change-password'})
        }
      } else {
        this.$emit('login')
      }
    },
    refreshCaptchaCode () {
      request('fetchCaptchaCode').then(({data}) => {
        this.codeImageData = 'data:image/png;base64,' + data['imgdata']
        this.captchaCodeToken = data['SJ_CaptchaCode_Token']
      })
    },
    isStrongPwd (pwd) {
      return pwd.length >= 8 && [/[\u0020-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]/, /[0-9]/, /[a-z]/, /[A-Z]/].map(regex =>
        regex.test(pwd)
      ).reduce((result, current) => {
        return result && current
      }, true)
    },
  },
}
</script>
<style lang="scss">
.captchacode-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.login-body {
  background: #2d2f33 url() no-repeat fixed;
  background-size: cover;
  height: 100%;
}

.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 100px;
}

.form-signin {
  max-width: 330px;
  margin: 0 auto;
  background: #fff;
  border-radius: 6px;

  .form-signin-heading {
    margin: 0;
    padding: 25px 15px;
    text-align: center;
    color: #fff;
    position: relative;
  }

  .sign-title {
    font-size: 24px;
    color: #fff;
    position: absolute;
    top: -60px;
    left: 0;
    text-align: center;
    width: 100%;
    text-transform: uppercase;
  }

  input[type="text"],
  input[type="password"] {
    // font-weight: lighter;
    letter-spacing: 1px;
    -webkit-border-radius: 5px;
    border: 1px solid #eaeaec;
    background: #eaeaec;
    box-shadow: none;
    font-size: 12px;
    position: relative;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
    display: block;
    width: 100%;
    line-height: 1.42857143;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

    &::placeholder {
      color: #878d99;
    }
  }

  .el-form-item.is-success {
    .el-input__inner,
    .el-input__inner:focus {
      border-color: #eaeaec;
    }
  }

  .submit-btn {
    width: 100%;

    i {
      font-size: 18px;
      font-weight: bolder;
    }
  }
}

.login-wrap {
  padding: 20px;
  padding-top: 0;
  position: relative;

  .registration {
    color: #c7c7c7;
    text-align: center;
    margin-top: 15px;
  }

  .login-error {
    font-size: 12px;
    color: #fa5555;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/Login.vue